import React, { useRef, useState } from "react"

import * as styles from "./nav.module.scss"
import config from "@config"
import Clickable from "../clickable"
import { useNavScrollHide } from "gpages/hooks/common"
import { scrollToTarget } from "gpages/utils/common"
import logoImg from "@images/logo.svg"
import burgerImg from "@images/burger.svg"
import classnames from "gpages/utils/classnames"

const ITEMS = [
  {
    key: "ticketInfo",
    title: "票务",
  },
  {
    key: "intro",
    title: "活动介绍",
  },
  {
    key: "play",
    title: "游戏玩法",
  },
  {
    key: "guests",
    title: "嘉宾",
  },
  {
    key: "stage",
    title: "舞台活动",
  },
  {
    key: "sales",
    title: "机核品牌",
  },
  {
    key: "exhibitors",
    title: "参展商",
  },
  {
    key: "indie",
    title: "独立游戏",
  },
  {
    key: "partners",
    title: "合作伙伴",
  },
  {
    key: "media",
    title: "合作媒体",
  },
  {
    key: "ticket",
    title: "立即购票",
    url: config.data.ticketUrl,
    bg: true,
  },
]

const Nav = ({ location }) => {
  const [dropdownVisble, setDropdownVisible] = useState(false)
  const visible = useNavScrollHide()

  const handleItemClick = (e) => {
    setDropdownVisible(false)
    const scrolled = scrollToTarget(e.currentTarget)
    if (scrolled) {
      e.preventDefault()
    }
  }

  return (
    <nav
      className={classnames(styles.nav, {
        [styles.isDropdown]: dropdownVisble,
        [styles.isHide]: !visible,
      })}
    >
      <Clickable
        className={styles.dropDownMask}
        onClick={() => {
          setDropdownVisible(false)
        }}
      />
      <div>
        <div className={styles.logoContainer}>
          <img src={logoImg} alt="logo" className={styles.logo} />
        </div>
        <div className={styles.right}>
          <Clickable
            className={styles.menuBtn}
            onClick={() => {
              setDropdownVisible((prev) => !prev)
            }}
          >
            <img src={burgerImg} alt="menu" />
          </Clickable>
          <div className={styles.menu}>
            <ul>
              {ITEMS.map(({ title, key, url, bg }) => {
                return (
                  <li key={title}>
                    <Clickable
                      newWindow={false}
                      href={url ? undefined : `#${key}`}
                      appNavTo={url}
                      onClick={handleItemClick}
                      className={bg ? styles.itemBg : undefined}
                    >
                      {title}
                    </Clickable>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Nav
